import { takeLatest, call, put } from 'redux-saga/effects';
import dataApi from '../../apis/dataApi';
import * as constants from './constants';
import * as actions from './actions';
import handleError from '../handleError';
import { notify } from 'features/notificationSystem/actions';

export function* fetchFeedback(action) {
  const marketCode = action.payload;
  try {
    const response = yield call(dataApi.fetchFeedback, marketCode);
    yield put(actions.fetchFeedbackDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchFeedbackFail',
      put(actions.fetchFeedbackFail(error))
    );
  }
}
export function* fetchFeedbackCount(action) {
  //const marketCode = action.payload;
  try {
    const response = yield call(dataApi.fetchFeedbackCount);
    yield put(actions.fetchFeedbackCountDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchFeedbackFail',
      put(actions.fetchFeedbackCountFail(error))
    );
  }
}
export function* highlightFeedback(action) {
  const storeID = action.payload;
  try {
    const response = yield call(dataApi.highlightFeedback, storeID);
    yield put(actions.highlightFeedbackDone(response.data));
    yield put(
      notify({
        message: response.data.message,
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.highlightFeedbackFail',
      put(actions.highlightFeedbackFail(error))
    );
  }
}

export function* deleteFeedback(action) {
  const storeID = action.payload;
  try {
    const response = yield call(dataApi.deleteFeedback, storeID);
    yield put(actions.deleteFeedbackDone(response.data));
    yield put(
      notify({
        message: response.data.message,
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.deleteFeedbackFail',
      put(actions.deleteFeedbackFail(error))
    );
  }
}
export default [
  takeLatest(constants.FETCH_FEEDBACK, fetchFeedback),
  takeLatest(constants.FETCH_FEEDBACK_COUNT, fetchFeedbackCount),
  takeLatest(constants.HIGHLIGHT_FEEDBACK, highlightFeedback),
  takeLatest(constants.DELETE_FEEDBACK, deleteFeedback)
];
